function getTeamInitial(text: string) {
  return text.charAt(0);
}

export { getTeamInitial };
